import { AppContext, appActions } from 'in-meeting-experience-ui-components/contexts/app/context';
import { captureException } from 'raven-js';
import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMeetingId, getMeetingSpace, getConferenceRecord } from '../slices/google/actions';
import { clientSelector, googleConferenceRecordIdSelector, meetingIdSelector } from '../slices/google/selectors';
const useGoogleMeeting = () => {
  const dispatch = useDispatch();
  const {
    isPastMeeting
  } = useContext(AppContext);
  const sdkClient = useSelector(clientSelector);
  const meetingId = useSelector(meetingIdSelector);
  const conferenceRecordId = useSelector(googleConferenceRecordIdSelector);
  const [isMeetingIdLoading, setIsMeetingIdLoading] = useState(!meetingId);
  const [isConferenceRecordIdLoading, setIsConferenceRecordIdLoading] = useState(!conferenceRecordId);
  useEffect(() => {
    if (sdkClient && !meetingId) {
      dispatch(getMeetingId(sdkClient)).then(() => {
        setIsMeetingIdLoading(false);
      }).catch(captureException);
    }
  }, [sdkClient, dispatch, meetingId]);
  useEffect(() => {
    if (meetingId && !isPastMeeting) {
      dispatch(getMeetingSpace(meetingId)).then(() => {
        setIsConferenceRecordIdLoading(false);
      }).catch(captureException);
    }
  }, [meetingId, dispatch, conferenceRecordId, isPastMeeting]);
  useEffect(() => {
    if (meetingId && conferenceRecordId) {
      dispatch(getConferenceRecord(conferenceRecordId));
      appActions.setIsInMeeting(true);
    }
  }, [meetingId, conferenceRecordId, dispatch]);
  return isMeetingIdLoading || isConferenceRecordIdLoading;
};
export default useGoogleMeeting;